export const colorLines = ({ colorLines }) => colorLines.byId;
